import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from './globals';
import { BillingInfo } from 'app/models/billing-info';

@Injectable({ providedIn: 'root' })
export class BillingService {

    constructor(private http: HttpClient, private globals: Globals) {
    }

    info() {
        return this.http.get<BillingInfo>(`${this.globals.api_base_url}/billing/info`);
    }

    deletePaymentMethod(paymentMethodId: string) {
        return this.http.delete(`${this.globals.api_base_url}/billing/payment_method`, {
            params: {
                payment_method_id: paymentMethodId
            }
        });
    }

    setPaymentMethodAsDefault(paymentMethodId: string) {
        return this.http.post<any>(`${this.globals.api_base_url}/billing/payment_method/set_default`, {
            payment_method_id: paymentMethodId
        });
    }

    checkoutAddPaymentMethod() {
        return this.http.post<any>(`${this.globals.api_base_url}/billing/payment_method/checkout`, {});
    }

    checkout(features: string[], isAnnual: boolean) {
        return this.http.post<any>(`${this.globals.api_base_url}/billing/checkout`, {
            is_annual: isAnnual,
            features_internal_names: features
        });
    }

    changeSubscription(features: any, isAnnual: boolean) {
        return this.http.post<any>(`${this.globals.api_base_url}/billing/change_subscription`, {
            is_annual: isAnnual,
            features_internal_names: features
        });
    }

    changeCompanyName(companyName: string) {
        return this.http.post<any>(`${this.globals.api_base_url}/billing/company_name`, {
            company_name: companyName
        });
    }
}